import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import './Component_EncounterFeedItem.scss';
import { _className, AwaitModules, ComponentSync, Grid, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_ToolTip, openContent } from '@nu-art/thunderstorm-frontend';
import { EncounterFeedItem } from '../../../../structs/EncounterFeedItem/EncounterFeedItem.js';
import { EncounterFeedType, EncounterTypeToEntity } from '@app/advisor-v5-shared';
import { ProtocolData } from '../../../../_utils/ProtocolData/ProtocolData.js';
import { arrayIncludesAny, asArray, dbObjectToId, filterDuplicates, filterInstances } from '@nu-art/ts-common';
import { dispatch_onRuntimeActiveNavState, dispatch_onRuntimeFindingsUpdated, dispatch_onRuntimeOrdersUpdated, dispatch_onRuntimeProtocolsUpdated, ModuleFE_Advisor_Action, ModuleFE_Advisor_Resource, ModuleFE_RuntimeFinding, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { FindingType_Numeric } from '@app/advisor-shared';
import { Tooltip_Finding_Numeric } from '@app/advisor-ui-frontend';
import { FindingData } from '../../../../_utils/FindingData/FindingData.js';
import { ICONS } from '@app/styles';
import { Component_AdvisorSL_FeedItem } from '../../../loaders/skeleton/catch-up/recap/Component_AdvisorSL_FeedItem.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
const modulesToAwait = [
    ...ProtocolData.modulesToAwait,
    ...FindingData.modulesToAwait,
    ...EncounterFeedItem.modulesToAwait,
];
class Component extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.feedItem = EncounterFeedItem.createNew(nextProps.feedItem._id);
        state.relatedProtocols = this.getRelatedProtocols(state.feedItem?.resolveProtocolIds());
        state.renderContext = nextProps.renderContext;
        return state;
    }
    componentDidMount() {
        //instantiate dispatch listener methods based on the feed item type
        const item = this.state.feedItem?.feedItem;
        switch (item?.itemType) {
            case EncounterFeedType.ProtocolConsiderationSwitch:
                this.subscribeListener.protocol(item.payload.protocolId);
                break;
            case EncounterFeedType.ProtocolNavigation:
                this.subscribeListener.pathway(item.payload.pathwayId);
                this.subscribeListener.activeState(item.payload.stateId);
                break;
            case EncounterFeedType.OrderSent:
                this.subscribeListener.pathway(item.payload.relatedPathwayIds);
                this.subscribeListener.order(item.payload.runtimeId);
                break;
            case EncounterFeedType.OrderResulted:
                this.subscribeListener.pathway(item.payload.relatedPathwayIds);
                this.subscribeListener.order(item.payload.runtimeId);
                this.subscribeListener.orderFindings(item.payload.runtimeId);
                break;
        }
    }
    // ######################## Logic ########################
    subscribeListener = {
        pathway: (ids) => {
            // @ts-ignore
            this[dispatch_onRuntimeProtocolsUpdated.method] = (...params) => {
                const scope = asArray(params[1]).map(i => i.pathwayId);
                if (!arrayIncludesAny(asArray(ids), scope))
                    return;
                //Re-calculate related protocols
                this.setState({ relatedProtocols: this.getRelatedProtocols(this.state.feedItem?.resolveProtocolIds()) });
            };
        },
        protocol: (ids) => {
            // @ts-ignore
            this[dispatch_onRuntimeProtocolsUpdated.method] = (...params) => {
                const scope = asArray(params[1]).map(dbObjectToId);
                if (!arrayIncludesAny(asArray(ids), scope))
                    return;
                //Re-calculate related protocols
                this.setState({ relatedProtocols: this.getRelatedProtocols(this.state.feedItem?.resolveProtocolIds()) });
            };
        },
        activeState: (id) => {
            // @ts-ignore
            this[dispatch_onRuntimeActiveNavState.method] = (...params) => {
                if (asArray(params[1]).some(i => i._id === id))
                    this.forceUpdate();
            };
        },
        order: (id) => {
            // @ts-ignore
            this[dispatch_onRuntimeOrdersUpdated.method] = (...params) => {
                if (asArray(params[1]).some(i => i._id === id))
                    this.forceUpdate();
            };
        },
        orderFindings: (id) => {
            // @ts-ignore
            this[dispatch_onRuntimeFindingsUpdated.method] = (...params) => {
                if (asArray(params[1]).some(f => f.runtimeOrderId === id))
                    this.forceUpdate();
            };
        }
    };
    getRelatedProtocols(ids) {
        if (!ids?.length)
            return;
        return filterInstances(ids.map(id => ProtocolData.createNew(id)));
    }
    getTailData_OrderResulted = (rtOrderId) => {
        const rtOrder = ModuleFE_RuntimeOrder.cache.unique(rtOrderId);
        if (!rtOrder)
            return;
        const dbOrder = ModuleFE_Advisor_Action.cache.unique(rtOrder.orderId);
        if (!dbOrder)
            return;
        const resource = ModuleFE_Advisor_Resource.cache.unique(dbOrder.resourceId);
        if (!resource)
            return;
        const findings = ModuleFE_RuntimeFinding.cache.filter(f => f.runtimeOrderId === rtOrderId);
        return {
            rtOrder, dbOrder, resource,
            findings: filterInstances(findings.map(f => FindingData.createNew(f))),
        };
    };
    resolveResourceIcon = (resource) => {
        switch (resource.type) {
            case 'Consultations':
                return ICONS.advisor_avn_consultation.component;
            case 'EKG':
                return ICONS.advisor_avn_ekg.component;
            case 'Imaging':
                return ICONS.advisor_avn_imaging.component;
            case 'Laboratory':
                return ICONS.advisor_avn_labs.component;
            default:
                return ICONS.advisor_avn_medication.component;
        }
    };
    onClick = (e) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
        const change = this.state.feedItem.feedItem.itemType;
        const entity = EncounterTypeToEntity[change];
        this.state.feedItem?.onClick(e);
        this.props.onClick?.();
        ModuleFE_AdvisorAnalytics.trigger.eventLog.eventLog_itemClicked({
            entity, change,
            context: this.state.renderContext,
        });
    };
    getTTLogic_OrderResults = (data) => {
        const change = this.state.feedItem.feedItem.itemType;
        const entity = EncounterTypeToEntity[change];
        const original = openContent.tooltip.left('tt__efi-order-results', () => this.render_TT_OrderResults(data), { offset: 8 });
        return {
            onMouseEnter: e => {
                original.onMouseEnter(e);
                ModuleFE_AdvisorAnalytics.trigger.eventLog.eventLog_itemExpanded({
                    entity,
                    change,
                    context: this.state.renderContext,
                    source: 'data'
                });
            },
            onMouseLeave: original.onMouseLeave,
        };
    };
    getTTLogic_Protocols = (protocols) => {
        const change = this.state.feedItem.feedItem.itemType;
        const entity = EncounterTypeToEntity[change];
        const original = openContent.tooltip.bottom('tt__efi-protocols', () => this.render_TT_Protocols(protocols), { offset: 10 });
        return {
            onMouseEnter: e => {
                original.onMouseEnter(e);
                ModuleFE_AdvisorAnalytics.trigger.eventLog.eventLog_itemExpanded({
                    entity,
                    change,
                    context: this.state.renderContext,
                    source: 'protocols'
                });
            },
            onMouseLeave: original.onMouseLeave,
        };
    };
    // ######################## Render ########################
    render() {
        if (!this.state.feedItem)
            return;
        return _jsxs(LL_H_C, { className: 'c__encounter-feed-item', onClick: this.onClick, "data-variant": this.state.feedItem.feedItem.itemType, children: [this.render_Main(this.state.feedItem), this.render_Tail()] });
    }
    // ######################## Render - Main ########################
    render_Main = (feedItem) => {
        return _jsxs(LL_V_L, { className: 'efi__main', children: [this.render_Title(feedItem), _jsxs(LL_H_C, { className: 'efi__subtitle', children: [_jsx("div", { className: 'efi__timestamp', children: feedItem.resolveTimestamp() }), this.render_Protocols()] })] });
    };
    render_Title = (feedItem) => {
        const labelSegments = feedItem.resolveLabel();
        return _jsx("div", { className: 'efi__title', children: labelSegments.map((seg, i) => {
                return seg.unique
                    ? _jsx("span", { children: seg.text }, i)
                    : _jsx(Fragment, { children: seg.text }, i);
            }) });
    };
    render_Protocols = () => {
        const protocols = this.state.relatedProtocols;
        if (!protocols?.length)
            return;
        const label = () => {
            if (protocols.length === 1)
                return _jsx("div", { className: 'efi__protocol-label', children: protocols[0].getLabel() });
            return _jsx("div", { className: 'efi__protocol-multi-label', ...this.getTTLogic_Protocols(protocols), children: "Multiple Protocols" });
        };
        const colors = filterDuplicates(filterInstances(protocols.map(p => p.getColor())));
        return _jsxs(LL_H_C, { className: 'efi__protocols', children: [_jsx(LL_H_C, { className: 'efi__protocol-dots', children: colors.map(color => {
                        const style = { '--color': color };
                        return _jsx("div", { style: style }, color);
                    }) }), label()] });
    };
    // ######################## Render - Tail ########################
    render_Tail = () => {
        const item = this.state.feedItem?.feedItem;
        switch (item?.itemType) {
            case EncounterFeedType.OrderResulted:
                return this.render_Tail_Findings(item.payload.runtimeId);
            default:
                return _jsx(_Fragment, {});
        }
    };
    render_Tail_Findings = (rtOrderId) => {
        const data = this.getTailData_OrderResulted(rtOrderId);
        if (!data || !data.findings.length)
            return;
        //Render singular numeric result
        if (data.findings.length === 1 && data.findings[0].finding.type === FindingType_Numeric) {
            const finding = data.findings[0];
            const value = finding.getValue(true);
            const className = _className('efi-tail numeric-finding', data.findings[0].isAbnormal() && 'abnormal');
            return _jsx(Tooltip_Finding_Numeric, { modules: FindingData.tooltipModules, data: finding.getTooltipData(), onTooltipOpened: () => {
                    const change = this.state.feedItem.feedItem.itemType;
                    const entity = EncounterTypeToEntity[change];
                    ModuleFE_AdvisorAnalytics.trigger.eventLog.eventLog_itemExpanded({ entity, change, context: this.state.renderContext, source: 'data' });
                }, children: _jsx("div", { className: className, children: value }) });
        }
        //Render grouped results
        const Icon = this.resolveResourceIcon(data.resource);
        const hasAbnormalResults = data.findings.some(f => f.isAbnormal());
        const className = _className('efi-tail multi-findings', hasAbnormalResults && 'abnormal');
        return _jsx("div", { className: className, ...this.getTTLogic_OrderResults(data), children: _jsx(Icon, {}) });
    };
    // ######################## Render - TT Content ########################
    render_TT_Protocols = (protocols) => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'title', children: "Multiple Protocols" }), protocols.map(p => {
                    const style = { '--color': p.getColor() };
                    return _jsxs(LL_H_C, { children: [_jsx("div", { className: 'protocol-color', style: style }), p.getLabel()] }, p.protocol._id);
                })] });
    };
    render_TT_OrderResults = (data) => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'title', children: data.dbOrder.label ?? data.dbOrder.name }), _jsx(Grid, { className: 'finding-grid', children: data.findings.map(f => {
                        const className = _className('value', f.isAbnormal() && 'abnormal');
                        return _jsxs(Grid, { children: [_jsx("div", { className: 'label', children: f.getLabel() }), _jsx("div", { className: className, children: f.getValue(true) })] }, f.finding._id);
                    }) })] });
    };
}
export const Component_EncounterFeedItem = (p) => _jsx(AwaitModules, { Component: () => _jsx(Component, { ...p }), modules: modulesToAwait, customLoader: Component_AdvisorSL_FeedItem });
//# sourceMappingURL=Component_EncounterFeedItem.js.map